import './GiSearch.scss';
import template from './GiSearch.vhtml';
import $ from 'jquery';
import EventBus from '../eventBus';

export default {
	name: 'GiSearch',
	template: template,
	props: {
		homeUrl: {
			type: String,
			default: '/',
		},
	},
	data: () => ({
		searchString: '',
		searchFor: '',
		results: [],
		totalResults: null,
		loading: false,
		ready: false,
		noResults: true,
		showTop: false,
	}),
	computed: {
		resultsLabel() {
			if (this.totalResults === 1) {
				return 'resultat';
			} else {
				return 'resultater';
			}
		},
	},
	watch: {
		searchString(string) {
			this.inputChanged(string, this);
		},
	},
	methods: {
		getResults() {
			this.results = [];
			this.totalResults = null;
			if (this.searchFor.length > 2) {
				this.loading = true;
			}
			$.get(
				'/wp-json/gi/v1/search' +
					'?keyword=' +
					this.searchFor.replace(' ', '%20')
			)
				.then(result => {
					if (this.searchFor.length > 2) {
						this.results = result;
					} else {
						this.results = [];
						this.totalResults = null;
					}
					this.totalResults = this.results.length;
				})
				.catch(e => {
					console.log(e);
				})
				.always(() => {
					this.loading = false;
				});
		},
		inputChanged: debounce((string, vm) => {
			vm.searchFor = string;
			vm.getResults();
		}, 500),
		closeSearch() {
			EventBus.$emit('close-search');
		},
		clearSearch() {
			this.results = [];
			this.totalResults = null;
			this.searchFor = '';
			this.searchString = '';
		},
	},
	mounted() {
		this.showTop = true;
		setTimeout(() => {
			this.ready = true;
			this.$refs.search.focus();
		}, 100);
		EventBus.$emit('current-scrollpos', window.scrollY);
	},
};

// Lodash alternative
function debounce(fn, time) {
	let timeoutId;
	return wrapper;
	function wrapper(...args) {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(() => {
			timeoutId = null;
			fn(...args);
		}, time);
	}
}
